import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDvyJR8r5OjFM9Tk4nqxMXqi7oBmdwqw0I",
  authDomain: "davinqi-14ba6.firebaseapp.com",
  projectId: "davinqi-14ba6",
  storageBucket: "davinqi-14ba6.firebasestorage.app",
  messagingSenderId: "848867756077",
  appId: "1:848867756077:web:15f69709669ecb449790a4",
  measurementId: "G-8ZR0TQT331"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
